import React from 'react';
import { Outlet } from 'react-router-dom';
import UserApp from './HomePage';

const HomeLayout = () => {
  return (
    <>
      {/* HomePage reste toujours monté */}
      <UserApp />

      {/* Outlet pour les routes enfants (IndividualDetailPage) qui s'affichent par-dessus */}
      <Outlet />
    </>
  );
};

export default HomeLayout;
